import { userDataCollection } from "@/firebase";
import { TTMJ } from "@/store/enums";
import store from "@/store/store";
import firebase from "firebase/app";

export function taskCompleted(uid: string, task: TTMJ) {
  userDataCollection
    .doc(uid)
    .collection("ttmj")
    .doc("completionStatus")
    .update({
      [task]: { status: true, dateCompleted: Date.now() }
    })
    .then(success => {
      let user: any = firebase.auth().currentUser;
      store.dispatch("loadTTMJUserProgress", user.uid);
    })
    .catch(error => {
      store.dispatch("addNotification", {
        type: "error",
        value:
          "An error has occured while your reponse was being stored. Please try again!",
        timeout: 5000,
        icon: "mdi-account"
      });
    });
}
